import React, {Component} from 'react';
import {Switch, Route, withRouter} from 'react-router-dom'
import Items from './pages/Items';
import Login from './pages/Login';
import Logout from './pages/Logout';
import Signup from './pages/Signup';
import AddProduct from './pages/AddProduct';
import AddCategory from './pages/AddCategory';
import AddArticle from './pages/AddArticle';
import InfoUpdate from './pages/InfoUpdate';
import Article from './pages/Article';
import Cart from './pages/Cart';
import Articles from './pages/Articles';
import ShopSettings from './pages/ShopSettings';
import ShippingPaying from './pages/ShippingPaying';
import Product from './pages/Product';
import Orders from './pages/Orders';
import Payment from './pages/Payment';
import {Redirect} from 'react-router';
import {connect} from 'react-redux';

const PrivateRoute = ({
  component: Component,
  auth: Aauth,
  ...rest
}) => (<Route {...rest} render={(props) => (
    Aauth === true
    ? <Component {...props}/>
    : <Redirect to='/login'/>)}/>)

class Main extends Component {

  render() {
    return (
        <Switch>
          {/*<Route exact path='/' render={(props) => (<Items {...props} setMenuSelector={this.props.setMenuSelector}/>)}/>  <ScrollToTop  resChange={this.props.resChange} store={this.props.store}> */}
          {/*<Route exact path='/category/:slug' render={(props) => (<Items {...props} setMenuSelector={this.props.setMenuSelector}/>)}/> {/* <ScrollToTop  resChange={this.props.resChange} store={this.props.store}> */}
          <Route exact path='/' component={Items}/> {/* <ScrollToTop  resChange={this.props.resChange} store={this.props.store}> */}
          <Route exact path='/category/:slug' component={Items}/> {/* <ScrollToTop  resChange={this.props.resChange} store={this.props.store}> */}
          <Route exact path='/article/:slug' component={Article}/> {/* <ScrollToTop  resChange={this.props.resChange} store={this.props.store}> */}
          <Route exact path='/login' component={Login}/>
          <Route exact path='/login/:last' component={Login}/>
          <Route exact path='/cart' component={Cart}/>
          <Route exact path='/product/:slug' component={Product}/>
          <Route exact path='/payment/:paymentId' component={Cart}/>
          <Route exact path='/payment' component={Cart}/>
          <PrivateRoute exact path='/order/:id' component={Cart} auth={this.props.auth}/>
          <PrivateRoute exact path='/logout' component={Logout} auth={this.props.auth}/>
          <PrivateRoute exact path='/orders' component={Orders} auth={this.props.auth}/>
          <PrivateRoute exact path='/infoUpdate' component={InfoUpdate} auth={this.props.auth}/>
          <PrivateRoute exact path='/addproduct/:slug' component={AddProduct} auth={this.props.admin}/>
          <PrivateRoute exact path='/addproduct' component={AddProduct} auth={this.props.admin}/>
          <PrivateRoute exact path='/addcategory' component={AddCategory} auth={this.props.admin}/>
          <PrivateRoute exact path='/addarticle/:slug' component={AddArticle} auth={this.props.admin}/>
          <PrivateRoute exact path='/addarticle' component={AddArticle} auth={this.props.admin}/>
          <PrivateRoute exact path='/articles' component={Articles} auth={this.props.admin}/>
          <PrivateRoute exact path='/settings' component={ShopSettings} auth={this.props.admin}/>
          <PrivateRoute exact path='/shippingpaying' component={ShippingPaying} auth={this.props.admin}/>
          <Route exact path='/signup' component={Signup}/>
          <Route exact path='/signup/:last' component={Signup}/>
          <Route component={Items}/> {/* </ScrollToTop> */}
        </Switch>
      );
  }
}

function mapStateToProps(state) {
  return {auth: state.auth, admin: state.admin};
}
export default withRouter(connect(mapStateToProps)(Main))



// WEBPACK FOOTER //
// ./src/Main.js